import AWS from 'aws-sdk';

import jwtDecode from 'jwt-decode';

import config from '../../config';

import { USER_LOGGED_OUT, USER_LOGGED_IN } from '../constants/user';
import { ALERT_DISPLAY } from '../constants/alert';

import { checkTokenExpiration } from '../utils/checkTokenExpiration';
import { isDefined, isNullOrEmpty } from './../utils/utilities';
import { OKTA_VERSIONS } from '../constants';


import { signOut, signOutIdx, forgotPassword, resetPasswordLegacy } from '../../lib/authentication';

function setUserSession(idCredentials) {
    return new Promise((resolve, reject) => {
        idCredentials.get(error => {
            if (error) {
                reject(error);
            }
            resolve();
        });
    });
}

function setLastLogin(apiClient, userId) {
    return apiClient.profileIdPut({ id: userId }, [
        {
            fieldName: 'lastOnline',
            fieldValue: new Date().toISOString()
        }
    ]);
}

function initializeUser(apiClient, userId) {
    return apigClient.profileIdPut({ id: userId }, [
        { fieldName: 'status', fieldValue: 'active' },
        { fieldName: 'lastOnline', fieldValue: new Date().toISOString() },
        { fieldName: 'firstLogin', fieldValue: new Date().toISOString() }
    ]);
}

function initializeFullStory(user) {
    return new Promise((resolve, reject) => {
        FS.identify(user.username, {
            displayName: user.username,
            email_str: user.username,
            broker_str: user.brokerName,
            subId_str: user.id
        });
        resolve();
    });
}

function getClaimValue(tokenClaims, propName, defaultValue = null) {
    return propName in tokenClaims ? tokenClaims[propName] : defaultValue;
}

async function refreshCredentials(credentials) {
    return new Promise((resolve, reject) => {
        credentials.refresh(error => {
            if (error) {
                reject(error);
            }
            resolve();
        });
    });
}

export function logout() {
    return dispatch => {
        const signOutPromise = OE_ENV.OKTA_VERSION === OKTA_VERSIONS.V2 ? signOutIdx : signOut;
        signOutPromise().then(() => {
            window.location.replace(`${config.landingPageUrl}`);
            dispatch({ type: USER_LOGGED_OUT });
        })
    };
}

export function userForgotPassword(email, onSuccess, onFailure) {
    return forgotPassword(email, onSuccess, onFailure)
}

export function userConfirmPassword(recoveryToken, newPassword, onSuccess, onFailure) {
    return resetPasswordLegacy(recoveryToken, newPassword, onSuccess, onFailure)
}

export function editProfile(user, values) {
    return new Promise((resolve, reject) => {
        checkTokenExpiration(user).then(() => {
            const paramsArray = [
                { fieldName: 'firstName', fieldValue: values.firstName },
                { fieldName: 'lastName', fieldValue: values.lastName },
                {
                    fieldName: 'title',
                    fieldValue: isNullOrEmpty(values.jobTitle) ? ' ' : values.jobTitle
                },
                { fieldName: 'phone', fieldValue: values.phone },
                {
                    fieldName: 'phoneExt',
                    fieldValue: isNullOrEmpty(values.phoneExt) ? ' ' : values.phoneExt
                }
            ];

            apigClient.profileIdPut({ id: user.id }, paramsArray).then((resp2, err1) => {
                if (resp2.data && resp2.data.success === true) {
                    return resolve({
                        success: true,
                        data: resp2.data
                    });
                }
                return resolve({
                    success: false,
                    message: err1.message
                });
            });
        });
    });
}

export function updateUserValues(values) {
    return (dispatch, getState) => {
        const { user } = getState();
        dispatch({
            type: USER_LOGGED_IN,
            payload: {
                ...user,
                title: values.jobTitle,
                phoneExt: values.phoneExt,
                phone: values.phone,
                lastName: values.lastName,
                firstName: values.firstName
            },
            meta: { from: 'updateUserValues' }
        });
    };
}

export function createAlert(message, bsStyle, timeout = null, fnAfterAlert = () => {}) {
    return dispatch => {
        dispatch({
            type: ALERT_DISPLAY,
            payload: {
                message,
                bsStyle,
                show: true
            }
        });
        if (timeout !== null) {
            setTimeout(() => {
                dispatch({
                    type: ALERT_DISPLAY,
                    payload: {
                        message: '',
                        show: false
                    }
                });
                fnAfterAlert();
            }, timeout);
        }
    };
}
